import { useEffect, useState } from "react";

export function useSessionSuperuser() {
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [sessionLoading, setSessionLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setSessionLoading(true);
      try {
        const response = await fetch("/api/session");
        if (!response.ok) return;
        const body = (await response.json()) as { user?: { superuser?: boolean } };
        if (!cancelled) {
          setIsSuperuser(Boolean(body.user?.superuser));
        }
      } catch {
        // ignore
      } finally {
        if (!cancelled) {
          setSessionLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { isSuperuser, sessionLoading };
}
